// TODO: Move this component to @features/utm-guide/components.
import { useState } from "react";

import { useToasts } from "react-toast-notifications";

import { type NorthbeamUtmPlatform } from "@features/utm-guide";
import { addQueryParamsToUrl } from "@north-beam/nb-common";
import { PrimaryButton } from "@shared/buttons";

import { getNorthbeamUtmPlatformParams } from "../constants";

interface ConstructDestinationUrlProps {
  platform: NorthbeamUtmPlatform;
  doNotEncodeQueryParams?: boolean;
}

export function ConstructDestinationUrl({
  platform,
  doNotEncodeQueryParams,
}: ConstructDestinationUrlProps) {
  const { addToast } = useToasts();
  const [destinationUrl, setDestinationUrl] = useState<string>("");
  const [constructedUrl, setConstructedUrl] = useState<string>("");
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform,
  });

  return (
    <div className="flex flex-col gap-3">
      <div className="input-group">
        <textarea
          rows={4}
          className="form-control mb-0"
          style={{ wordBreak: "break-all" }}
          readOnly
          value={`${urlParamPairs
            .map(({ key, value }) => `${key}=${value}`)
            .join("&")}`}
        />
      </div>
      <div className="control-label mb-0" data-testid="destination-url-label">
        Paste the destination URL for your ad here. Make sure to include{" "}
        <code>https://</code> in the URL:
      </div>
      <input
        type="text"
        className="form-control mb-0"
        data-testid="destination-url-input"
        value={destinationUrl}
        onChange={(event) => setDestinationUrl(event.target.value)}
      />
      <p className="mb-0">
        Construct and copy the new URL with Northbeam&apos;s URL parameters.
      </p>
      <PrimaryButton
        onClick={() => {
          try {
            const newConstructedUrl = doNotEncodeQueryParams
              ? `${destinationUrl}?${urlParamPairs
                  .map(({ key, value }) => `${key}=${value}`)
                  .join("&")}`
              : addQueryParamsToUrl(destinationUrl, urlParamPairs);
            setConstructedUrl(newConstructedUrl);
            window.navigator.clipboard.writeText(newConstructedUrl);
            addToast("Copied to clipboard!", { appearance: "success" });
          } catch (err) {
            let message = "Problem creating URL!";
            if (err instanceof Error) {
              message = err.message;
            }
            addToast(message, { appearance: "error" });
          }
        }}
        isDisabled={destinationUrl === ""}
        style={{ maxWidth: "fit-content" }}
      >
        CONSTRUCT AND COPY
      </PrimaryButton>
      <div className="input-group">
        <textarea
          rows={4}
          className="form-control"
          readOnly
          value={constructedUrl}
        />
      </div>
    </div>
  );
}
